import { CircularProgress, Typography, Grid } from "@material-ui/core";
import * as React from "react";
import { createStyles, withStyles } from "@material-ui/core/styles";

const styles = createStyles({
  root: {
    height: "100%",
    width: "100%",
    display: "flex",
    alignContent: "center",
    justifyContent: "center",
  },
  loading: {
    color: "#2A2A55BB",
  },
});

class Loading extends React.Component<any> {
  constructor(props: any) {
    super(props);
  }

  public render() {
    const { classes } = this.props;
    return (
      <Grid
        container={true}
        classes={{
          container: classes.root,
        }}
      >
        <CircularProgress
          classes={{
            root: classes.loading,
          }}
          size={this.props.size || 80}
        />
      </Grid>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Loading);



// WEBPACK FOOTER //
// ./src/components/loading/loading.tsx